
// Only usable in client side
export default class Cache {
  private static readonly prefix = "cache_";
  private static readonly USER_PROFILE_PICTURE = this.prefix + "user_profile_picture";

  private static check() {
    return !process.server;
  }
  
  static set(key: string, value: any, expires_in: number = 0) {
    if (!this.check()) return;
    localStorage.setItem(key, value);
  }

  static get(key: string) {
    if (!this.check()) return;
    return localStorage.getItem(key);
  }

  static delete(key: string) {
    if (!this.check()) return;
    localStorage.removeItem(key);
  }

  static setUserProfilePicture(value: any) {
    this.set(this.USER_PROFILE_PICTURE, value);
  }

  static getUserProfilePicture() {
    return this.get(this.USER_PROFILE_PICTURE);
  }

  static deleteUserProfilePicture() {
    this.delete(this.USER_PROFILE_PICTURE);
  }

}